module.exports = __webpack_public_path__ + "img/rateBack.1403f12e.png";